/**
 * Die Spielfigur, gezeichnet aus ihrem Aussehen. Die Füße stehen im Ursprung;
 * Größe, Position und Blickrichtung setzt der Aufrufer per Transform.
 */
import type { Appearance } from '../../lib/appearance';

interface Props {
  a: Appearance;
  legSwing?: number;
}

export function PlayerFigure({ a, legSwing = 0 }: Props) {
  return (
    <g>
      <ellipse cx="0" cy="2" rx="12" ry="3" fill="#000" opacity="0.25" />
      <line x1="-4" y1="-22" x2={-4 + legSwing} y2="0" stroke={a.pants} strokeWidth="5" strokeLinecap="round" />
      <line x1="4" y1="-22" x2={4 - legSwing} y2="0" stroke={a.pants} strokeWidth="5" strokeLinecap="round" />
      <rect x="-9" y="-44" width="18" height="24" rx="5" fill={a.shirt} />
      <line x1="-9" y1="-40" x2={-13 - legSwing / 2} y2="-26" stroke={a.shirt} strokeWidth="4" strokeLinecap="round" />
      <line x1="9" y1="-40" x2={13 + legSwing / 2} y2="-26" stroke={a.shirt} strokeWidth="4" strokeLinecap="round" />
      <circle cx="0" cy="-54" r="9" fill={a.skin} />
      {a.hair === 'kurz' && <path d="M -9 -55 Q 0 -66 9 -55 Q 4 -60 0 -60 Q -4 -60 -9 -55 Z" fill={a.hairColor} />}
      {a.hair === 'lang' && (
        <path d="M -10 -56 Q 0 -68 10 -56 L 12 -38 Q 0 -42 -12 -38 Z" fill={a.hairColor} />
      )}
    </g>
  );
}
